import authBootstrap from './authBootstrap.js'
import appSettings from './appSettings.js'
import readAccess from './readAccess.js'
import roleContractMatrix from './roleContractMatrix.js'
import permissionProbes from './permissionProbes.js'
import studentsCrud from './studentsCrud.js'
import otherPlan from './otherPlan.js'
import studentEditScope from './studentEditScope.js'
import documentsAccess from './documentsAccess.js'
import usersCrud from './usersCrud.js'
import feedbackTemplateCrud from './feedbackTemplateCrud.js'
import feedbackCloseLock from './feedbackCloseLock.js'
import feedbackViewerShare from './feedbackViewerShare.js'
import meetingReconcileGate from './meetingReconcileGate.js'
import meetingsCrud from './meetingsCrud.js'
import meetingDefaults from './meetingDefaults.js'
import genEdHours from './genEdHours.js'
import studentEvaluationCrud from './studentEvaluationCrud.js'
import evalCaseManagerMirror from './evalCaseManagerMirror.js'
import evalCardLifecycle from './evalCardLifecycle.js'
import evalFillableShell from './evalFillableShell.js'
import referralAccess from './referralAccess.js'
import evalOutcomeApply from './evalOutcomeApply.js'
import extendedAccess from './extendedAccess.js'
import aideSchedules from './aideSchedules.js'
import emailConfig from './emailConfig.js'
import testingModule from './testingModule.js'
import schoolsTenancy from './schoolsTenancy.js'
import studentPrivate from './studentPrivate.js'
import refDocuments from './refDocuments.js'
import encryptedPdfs from './encryptedPdfs.js'
import adminFerpa from './adminFerpa.js'
import importWorkflow from './importWorkflow.js'
import districtAccess from './districtAccess.js'
import saleReadiness from './saleReadiness.js'

// Order matters: read-only checks first so a broken bootstrap fails fast
// before any destructive scenario writes anything.
export const scenarios = [
  authBootstrap,
  appSettings,
  readAccess,
  roleContractMatrix,
  permissionProbes,
  importWorkflow,
  districtAccess,
  saleReadiness,
  studentsCrud,
  otherPlan,
  studentEditScope,
  documentsAccess,
  usersCrud,
  feedbackTemplateCrud,
  feedbackCloseLock,
  feedbackViewerShare,
  meetingReconcileGate,
  meetingsCrud,
  meetingDefaults,
  genEdHours,
  studentEvaluationCrud,
  evalCaseManagerMirror,
  evalCardLifecycle,
  evalFillableShell,
  referralAccess,
  evalOutcomeApply,
  extendedAccess,
  aideSchedules,
  emailConfig,
  testingModule,
  schoolsTenancy,
  studentPrivate,
  refDocuments,
  encryptedPdfs,
  adminFerpa
]
